import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs, Button } from '@blueprintjs/core';
import ALRTab from './ALRTab.js'

class ALR extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId:Object.keys(this.props.alrOcc).length===2? Object.keys(this.props.alrOcc)[1]:"Global"
  }
 
  handleTabChange = (navbarTabId) => {
    this.setState({ selectedTabId: navbarTabId });
    //  this trick is to cope with the react-apex-chart show problem
    window.dispatchEvent(new Event('resize'));
  }

  render() {
      const { alrSpec, alrOcc, displayRunAgain, t } = this.props;
      console.log(this.state.selectedTabId);
      console.log(this.props.alrOcc);
      const tabs = [];

      // generate the global page, only when more than one page
      if (Object.keys(alrOcc).length > 2) {
        if (alrOcc['_global_']) {
          const alrTab = <ALRTab 
                              alrOcc={alrOcc['_global_']} 
                              alrSpec={alrSpec} 
                              displaySpec={false} 
                              performSearch={this.props.performSearch}                              
                          />;
          const tab = <Tab key='Global' id='Global' title={t('global')} panel={alrTab} />;
          tabs.push(tab);
        }
      }

      // generate the indidual stat pages (sub-corpus or partition)
      const subCorpora=Object.keys(alrOcc).sort();
      for (var i=0;i<subCorpora.length;i++) {
        const subCorpus=subCorpora[i];
        if (subCorpus!=='_global_' && alrOcc[subCorpus] ) {
          const alrTab = <ALRTab  alrOcc={alrOcc[subCorpus]} 
                                  alrSpec={alrSpec} 
                                  displaySpec={true} 
                                  performSearch={this.props.performSearch}
                          />;
          const tab = <Tab key={subCorpus} id={subCorpus} title={subCorpus} panel={alrTab} />;
          tabs.push(tab);
        }
      }

      return (
        <>
        { tabs.length===0 && 
          <div>
            {t('noAlr')}  
          </div>
        }
        { displayRunAgain &&

          <div>
            <p>{t('onlyASampleOfTheCorpusHasBeenSearched')}</p>
            <Button onClick={this.props.runAgain}>{t('runAgain')}</Button>
          </div>
        }        
        { tabs.length>0 && 
          <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
            {tabs}
          </Tabs>
        }

        </>
      );
  }
}

ALR.propTypes = {
  alrOcc: PropTypes.object,
  alrSpec: PropTypes.object,
  runAgain:  PropTypes.func,
  displayRunAgain: PropTypes.bool,
  performSearch: PropTypes.func,
};

export default withTranslation()(ALR);
